import ProjectsFilter from './ProjectsFilter';

const initProjectsFilter = () => { 
  if (document.getElementsByClassName('archive-projects-wrapper').length > 0) {
    let filter = document.getElementsByClassName('filter-projects')[0];
    let list = document.getElementsByClassName('list-projects')[0];
    new ProjectsFilter(filter, list);
  }
}

initProjectsFilter();


// WEBPACK FOOTER //
// ./ui/assets/js/ProjectsFilter/init.js